import React from 'react';
import './AuditLogTable.css';

const AuditLogTable = ({ logs }) => {
if (!logs || logs.length === 0) {
  return (
    <div className="audit-log-table">
      <p className="empty-state">No audit logs available.</p>
    </div>
  );
}

  return (
    <div className="audit-log-table" role="region" aria-label="Audit logs table">
      <table>
        <thead>
          <tr>
            <th>Timestamp</th>
            <th>Action</th>
            <th>Status</th>
            <th>User</th>
            <th>Role</th>
            <th>PII Type</th>
            <th>Target</th>
            <th>Source</th>
            <th>IP</th>
            <th>Correlation</th>
          </tr>
        </thead>

        <tbody>
          {logs.map((log) => (
            <tr key={log.id}>
              <td>
                {log.timestamp
                  ? new Date(log.timestamp).toLocaleString()
                  : '—'}
              </td>

              <td>
                <strong>{log.actionType}</strong>
              </td>

              <td>
                <span className={`status ${log.actionStatus?.toLowerCase() || 'unknown'}`}>
                  {log.actionStatus || 'UNKNOWN'}
                </span>
              </td>

              <td>{log.actorUsername || 'system'}</td>

              <td>{log.actorRole || '—'}</td>

              <td>{log.piiType || '—'}</td>

              <td>
                {log.targetObjectType
                  ? `${log.targetObjectType}${log.targetObjectId ? `: ${log.targetObjectId}` : ''}`
                  : '—'}
              </td>

              <td>{log.source || '—'}</td>

              <td className="mono">{log.ipAddress || '—'}</td>

              <td className="mono" title={log.correlationId}>
                {log.correlationId
                  ? log.correlationId.slice(0, 8) + '…'
                  : '—'}
              </td>
            </tr>
          ))}
        </tbody>

      </table>
    </div>
  );
};

export default AuditLogTable;
